import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import { disconnectFromHubrise } from '../../apis/hubrise';
import { isStringNotNull } from '../../utils/tools';
import { generateHubriseAccess, synchronizeMenuHubrise } from '../../apis/backend';
import {
  ERROR_CONNECTION_HUBRISE,
  ERROR_HUBRISE_SYNCHRONIZATION,
  ERROR_LOGOUT
} from '../../constants';
import { showNotification } from '../Notification/Notification.view';

export const hubriseLogout = async component => {
  const { openErrorModal } = component.props;
  try {
    component.setState({ isLoading: true });
    await disconnectFromHubrise();
  } catch (err) {
    openErrorModal(ERROR_LOGOUT);
  }
  component.setState({ isLoading: false });
};
export const initializeData = async component => {
  const { history = {}, openErrorModal } = component.props;
  const { location = {} } = history;
  component.setState({
    isLoading: true
  });
  try {
    if (isStringNotNull(location.search && location.search.split('code=')[1])) {
      await generateHubriseAccess(location.search.split('code=')[1]);
      window.history.replaceState(null, null, window.location.pathname);
    } else {
      component.setState({
        isLoading: false
      });
    }
  } catch (err) {
    component.setState({
      isLoading: false
    });
    window.history.replaceState(null, null, window.location.pathname);
    openErrorModal(ERROR_CONNECTION_HUBRISE);
  }
};

export const showConfirmation = component => {
  const { showModal } = component.props;
  const title = `Attention ! Vous vous apprêtez à écraser votre menu de manière irréversible pour le remplacer par celui provenant d'Hubrise ! êtes vous sure ?`;
  const modalData = {
    title,
    danger: true,
    showCancelBtn: true,
    onClick: () => {
      synchronzingData(component);
      showModal({
        ...modalData,
        loading: true
      });
    },
    btnTxt: 'Valider'
  };
  showModal(modalData);
};

export const synchronzingData = async component => {
  const { openErrorModal, showModal } = component.props;
  try {
    component.setState({ loading: true });
    await synchronizeMenuHubrise();
    setTimeout(() => {
      showNotification(
        'light',
        'ltr',
        'primary',
        'Synchronisation réussie',
        `Votre menu a bien été synchronisé avec HubRise.`
      );
    }, 2000);
    component.setState({ showModal: false });
  } catch (err) {
    openErrorModal(ERROR_HUBRISE_SYNCHRONIZATION);
  }
  showModal(null);
  component.setState({ loading: false });
};
